import { Link } from 'react-router-dom';

const sizeMap = {
  full: 'w-full',
  medium: 'max-w-2xl mx-auto',
  small: 'max-w-sm mx-auto',
};

export default function BlockRenderer({ blocks = [] }) {
  if (!blocks || blocks.length === 0) return null;

  return (
    <div className="prose prose-lg max-w-none">
      {blocks.map((block, i) => {
        const d = block.data || {};
        
        switch (block.type) {
          case 'text':
            return (
              <p key={i} className="text-gray-700 leading-relaxed mb-6 text-base md:text-lg"
                dangerouslySetInnerHTML={{ __html: (d.text || '').replace(/\n/g, '<br/>') }} />
            );
          
          case 'heading':
            return d.level === 'h3' ? (
              <h3 key={i} className="font-heading text-xl md:text-2xl font-bold text-gray-900 mt-10 mb-4">{d.text}</h3>
            ) : (
              <h2 key={i} className="font-heading text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-5 pb-2 border-b border-gray-100">{d.text}</h2>
            );
          
          case 'image':
            return (
              <figure key={i} className={`my-8 ${sizeMap[d.size] || 'w-full'}`}>
                <div className="overflow-hidden rounded-xl shadow-sm">
                  <img src={d.url} alt={d.alt || d.caption || ''} 
                    className="w-full object-cover transition-transform hover:scale-[1.02]"
                    style={{ maxHeight: d.size === 'small' ? '300px' : d.size === 'medium' ? '400px' : '500px' }} />
                </div>
                {d.caption && (
                  <figcaption className="text-center text-sm text-gray-500 mt-3 italic">{d.caption}</figcaption>
                )}
              </figure>
            );
          
          case 'quote':
            return (
              <blockquote key={i} className="my-8 border-l-4 border-rsc-yellow bg-amber-50/50 rounded-r-lg px-6 py-5">
                <p className="text-lg md:text-xl italic text-gray-800 leading-relaxed">"{d.text}"</p>
                {d.author && <cite className="block mt-3 text-sm text-gray-500 not-italic">— {d.author}</cite>}
              </blockquote>
            );
          
          case 'cta':
            return (
              <div key={i} className="my-8 text-center">
                <Link to={d.link || '#'}
                  className={`inline-block px-8 py-3.5 rounded-full font-bold text-lg transition-all hover:shadow-lg hover:-translate-y-0.5 ${
                    d.style === 'outline' 
                      ? 'border-2 border-rsc-navy text-rsc-navy hover:bg-rsc-navy hover:text-white' 
                      : 'bg-rsc-yellow text-rsc-navy hover:bg-rsc-yellow-bright shadow-md'
                  }`}>
                  {d.text || 'Learn More'}
                </Link>
              </div>
            );
          
          case 'divider':
            return (
              <div key={i} className="my-10 flex items-center justify-center gap-3">
                <div className="h-px bg-gray-200 flex-1" />
                <div className="flex gap-1.5">
                  <div className="w-1.5 h-1.5 rounded-full bg-rsc-yellow" />
                  <div className="w-1.5 h-1.5 rounded-full bg-rsc-navy" />
                  <div className="w-1.5 h-1.5 rounded-full bg-rsc-yellow" />
                </div>
                <div className="h-px bg-gray-200 flex-1" />
              </div>
            );
          
          default:
            return null;
        }
      })}
    </div>
  );
}
